import type { TCheckboxListAvValues } from './checkboxList.type';

export const selectAll = (
  avValues: TCheckboxListAvValues,
): TCheckboxListAvValues[number]['value'][] => avValues.map(({ value }) => value);
